// src/pages/nascar/TrucksOdds.jsx
import React from "react";
import NascarBetting from "./NascarBetting";

export default function TrucksBettingPage() {
  return <NascarBetting series="trucks" />;
}
